<template>
  <div class="info_box">
    <div class="title">
      <div class="tab_lf">
        <span class="red-icon"></span>
        <span>{{title}}</span>
      </div>
    </div>
    <ul class="info_ul">
      <li class="info_li" v-if="qqShow==1">
        <span class="in_left">{{people}}</span>
        <span class="in_right">{{qq}}</span>
      </li>
      <li class="info_li" v-if="wechatShow==1">
        <span class="in_left">{{people}}</span>
        <span class="in_right">{{wechat}}</span>
      </li>
      <li class="info_li">
        <span class="in_left"><span class="red_x">*</span>会员账号</span>
        <span class="in_right"><input type="text" placeholder="请输入英文，数字" v-model="account" maxlength="20"></span>
      </li>
      <template v-if="sale_extend==1"> 
          <li class="info_li">
            <span class="in_left"><span class="red_x">*</span>VIP等级</span>
            <span class="in_right"><input type="number" placeholder="请输入VIP等级" v-model="VIPlevel" @keyup="VIPlevel=VIPlevel.replace(/^(|-[0-9][0-9]*)$/,'')" maxlength="10"></span>
          </li>
          <li class="info_li">
            <span class="in_left"><span class="red_x">*</span>电子等级</span>
            <span class="in_right"><input type="number" placeholder="请填写电子升级模式等级" v-model="electronicLevel" @keyup="electronicLevel=electronicLevel.replace(/^(|-[0-9][0-9]*)$/,'')" maxlength="10"></span>
          </li>
          <li class="info_li">
            <span class="in_left"><span class="red_x">*</span>真人等级</span>
            <span class="in_right"><input type="number" placeholder="请填真人升级模式等级" v-model="realPersonLevel" @keyup="realPersonLevel=realPersonLevel.replace(/^(|-[0-9][0-9]*)$/,'')" maxlength="10"></span>
          </li>
          <template v-if="isRetrieve !== 1">
              <li v-if="isShow.levelSalary" class="info_li">
                <span class="in_left">电子晋级礼金</span>
                <span class="in_right"><input type="number" placeholder="请填写电子晋级礼金" v-model="electronicGift" @keyup="electronicGift=electronicGift.replace(/^(|-[0-9][0-9]*)$/,'')" maxlength="10"></span>
              </li>
              <li v-if="isShow.weekSalary" class="info_li">
                <span class="in_left">电子周俸禄</span>
                <span class="in_right"><input type="number" placeholder="请填写电子周俸禄" v-model="electronicWeekMoeny" @keyup="electronicWeekMoeny=electronicWeekMoeny.replace(/^(|-[0-9][0-9]*)$/,'')" maxlength="10"></span>
              </li>
              <li v-if="isShow.monthSalary" class="info_li">
                <span class="in_left">电子月俸禄</span>
                <span class="in_right"><input type="number" placeholder="请填写电子月俸禄" v-model="electronicMonthMoeny" @keyup="electronicMonthMoeny=electronicMonthMoeny.replace(/^(|-[0-9][0-9]*)$/,'')" maxlength="10"></span>
              </li>
              <li v-if="isShow.levelSalary" class="info_li">
                <span class="in_left">真人晋级礼金</span>
                <span class="in_right"><input type="number" placeholder="请填写真人晋级礼金" v-model="realPersonLevelGift" @keyup="realPersonLevelGift=realPersonLevelGift.replace(/^(|-[0-9][0-9]*)$/,'')" maxlength="10"></span>
              </li>
              <li v-if="isShow.monthSalary" class="info_li">
                <span class="in_left">真人月俸禄</span>
                <span class="in_right"><input type="number" placeholder="请填写真人月俸禄" v-model="realPersonMonthMoeny" @keyup="realPersonMonthMoeny=realPersonMonthMoeny.replace(/^(|-[0-9][0-9]*)$/,'')" maxlength="10"></span>
              </li>
              <li class="info_li">
                <span class="in_left">电子棋牌累计有效投注</span>
                <span class="in_right"><input type="number" placeholder="请填写电子棋牌累计有效投注" v-model="ElectronicChessBetsAmount" @keyup="ElectronicChessBetsAmount=ElectronicChessBetsAmount.replace(/^(|-[0-9][0-9]*)$/,'')" maxlength="12"></span>
              </li>
              <li class="info_li">
                <span class="in_left">真人累计有效投注</span>
                <span class="in_right"><input type="number" placeholder="请填写真人累计有效投注" v-model="realPersonBetsAmount" @keyup="realPersonBetsAmount=realPersonBetsAmount.replace(/^(|-[0-9][0-9]*)$/,'')" maxlength="12"></span>
              </li>
          </template>
      </template>
      <template v-else>
        <li class="info_li">
          <span class="in_left"><span class="red_x">*</span>我的等级</span>
          <span class="in_right"><input type="text" placeholder="请输入您的等级" v-model="level" inputmode="numeric" @input="inputOnlyNumber('level')" maxlength="10"></span>
        </li>
        <li v-if="isShow.levelSalary" class="info_li">
          <span class="in_left">等级礼金</span>
          <span class="in_right"><input type="text" placeholder="请填写等级礼金，没填默认0" v-model="gift" inputmode="numeric" @input="inputOnlyNumber('gift')" maxlength="10"></span>
        </li>
        <li v-if="isShow.weekSalary" class="info_li">
          <span class="in_left">周俸禄</span>
          <span class="in_right"><input type="text" placeholder="请填写周俸禄，没填默认0" v-model="weekMoney" inputmode="numeric" @input="inputOnlyNumber('weekMoney')" maxlength="10"></span>
        </li>
        <li v-if="isShow.monthSalary" class="info_li">
          <span class="in_left">月俸禄</span>
          <span class="in_right"><input type="text" placeholder="请填写月俸禄，没填默认0" v-model="monthMoeny" inputmode="numeric" @input="inputOnlyNumber('monthMoeny')" maxlength="10"></span>
        </li>
      </template>
       <li class="info_li" v-if="type==1">
          <span class="in_left">其他</span>
          <span class="in_right"><input type="text" placeholder="您可以补充说明出售账号信息" v-model="textcon" maxlength="200"></span>
        </li>
        <li class="info_li">
          <span class="in_left"><span class="red_x">*</span>{{formWord(type)}}</span>
          <span class="in_right"><input type="text" placeholder="请输入金额" v-model="money" inputmode="numeric" @input="inputOnlyNumber('money')" maxlength="10"></span>
        </li>
    </ul>
    <div class="btn_in">
      <span class="btn_w_in" @click="sumbit()" :data="sale_extend">确认提交</span>
    </div>
  </div>
</template>

<script>
  import { assessResource, saleResource, recoverResource } from '@/resource/resource'
  import { getCookie } from '@/common/js/cookies'
  import { mapState } from 'vuex'
  const ERR_OK = 0
  export default {
    name: 'infolist',
    props: ['title', 'type', 'qq', 'qqShow', 'wechat', 'wechatShow', 'isRetrieve'],
    data () {
      return {
        account: '',
        level: '',
        gift: '',
        weekMoney: '',
        monthMoeny: '',
        VIPlevel: '',
        electronicLevel: '',
        realPersonLevel: '',
        electronicGift: '',
        electronicWeekMoeny: '',
        electronicMonthMoeny: '',
        realPersonLevelGift: '',
        realPersonMonthMoeny: '',
        ElectronicChessBetsAmount: '',
        realPersonBetsAmount: '',
        money: '',
        textcon: '',
        people: '',
        sale_extend: ''
      }
    },
    computed: {
      ...mapState(['config_info']),
      isShow() {
        const info = this.config_info ? this.config_info : {}
        const weekSalary = Number(info.week_salary_status) === 1
        const monthSalary = Number(info.month_salary_status) === 1
        const levelSalary = Number(info.finance_salary_status) === 1
        return { weekSalary, monthSalary, levelSalary }
      }
    },
    created () {
      this.sale_extend = localStorage.getItem('sale_extend')
      if (this.$route.name === 'sellpage') {
        this.people = '请添加出售专员'
      } else if (this.$route.name === 'evaluatepage') {
        this.people = '请添加评估专员'
      } else if (this.$route.name === 'recoverpage') {
        this.people = '请添加回收专员'
      }
    },
    mounted () {
    },
    methods: {
      formWord (status) {
        let ret = ''
        switch (status) {
          case 1:
            ret = '出售标价'
            break
          case 2:
            ret = '您的估价'
            break
          case 3:
            ret = '回收出价'
            break
          default:
            break
        }
        return ret
      },
      sumbit () {
        if (getCookie('isLogined')) { // 判断当前的isLogined是否存在
          if (!this.account) {
            this.$messagebox.alert('会员账号不能为空')
            return
          } else if (this.account.length < 4) {
            this.$messagebox.alert('会员账号不能少于4位')
            return
          } else if (parseInt(this.sale_extend) === 1) {
                if (!this.VIPlevel) {
                  this.$messagebox.alert('VIP等级不能为空')
                  return
                } else if (!this.electronicLevel) {
                  this.$messagebox.alert('电子等级不能为空')
                  return
                } else if (!this.realPersonLevel) {
                  this.$messagebox.alert('真人等级不能为空')
                  return
                }
          } else if (parseInt(this.sale_extend) === 0) {
             if (!this.level) {
                this.$messagebox.alert('等级不能为空')
                return
              }
          } else if (!this.money) {
            if (this.type === 1) {
              this.$messagebox.alert('出售标价不能为空')
            }
            if (this.type === 2) {
              this.$messagebox.alert('您的估值不能为空')
            }
            if (this.type === 3) {
              this.$messagebox.alert('回收出价不能为空')
            }
            return
          }
          this.sumbitData()
        } else {
          let urlG = '/' + this.$route.name
          this.$router.push({path: '/login', query: {redirect: urlG}})
        }
      },
      sumbitData () {
        let ret = {}
        if (parseInt(this.sale_extend) === 1) {
           ret = {
              account: this.account,
              vip_level: this.VIPlevel,
              e_level: this.electronicLevel,
              r_level: this.realPersonLevel,
              e_up_reward: this.electronicGift,
              e_month_reward: this.electronicMonthMoeny,
              e_week_reward: this.electronicWeekMoeny,
              r_up_reward: this.realPersonLevelGift,
              r_month_reward: this.realPersonMonthMoeny,
              e_bet_amount: this.ElectronicChessBetsAmount,
              r_bet_amount: this.realPersonBetsAmount,
              others: this.textcon
          }
        } else {
            ret = {
              account: this.account,
              e_level: this.level,
              e_up_reward: this.gift,
              e_week_reward: this.weekMoney,
              e_month_reward: this.monthMoeny,
              others: this.textcon
            }
            if (!this.gift) {
              ret.e_up_reward = 0
            }
            if (!this.weekMoney) {
              ret.e_week_reward = 0
            }
            if (!this.monthMoeny) {
              ret.e_month_reward = 0
            }
        }
        if (this.type === 1) {
          ret.sale_price = this.money
          ret.others = this.textcon
          this.saleP(ret)
        }
        if (this.type === 2) {
          ret.assess_price = this.money
          this.assessP(ret)
        }
        if (this.type === 3) {
          ret.recover_price = this.money
          this.recoverP(ret)
        }
      },
      saleP (data) {
        saleResource.sale(data).then(res => {
          res = res.body
          if (res.errcode === ERR_OK) {
            this.$messagebox.alert(res.data)
            this.clearForm()
          }
        })
      },
      assessP (data) {
        assessResource.assess(data).then(res => {
          res = res.body
          if (res.errcode === ERR_OK) {
            this.$messagebox.alert(res.data)
            this.clearForm()
          }
        })
      },
      recoverP (data) {
        recoverResource.recover(data).then(res => {
          res = res.body
          if (res.errcode === ERR_OK) {
            this.$messagebox.alert(res.data)
            this.clearForm()
          }
        })
      },
      clearForm () {
        this.account = ''
        this.level = ''
        this.gift = ''
        this.weekMoney = ''
        this.monthMoeny = ''
        this.VIPlevel = ''
        this.electronicLevel = ''
        this.realPersonLevel = ''
        this.electronicGift = ''
        this.electronicWeekMoeny = ''
        this.electronicMonthMoeny = ''
        this.realPersonLevelGift = ''
        this.realPersonMonthMoeny = ''
        this.ElectronicChessBetsAmount = ''
        this.realPersonBetsAmount = ''
        this.money = ''
        this.textcon = ''
      },
      inputOnlyNumber(key) {
        const val = this[key]
        if (!val) return
        this[key] = val.replace(/\D/g, '')
      }
    },
    components: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
.info_box
  margin-top 0.2rem
  color $c-b1
  font-size 0.28rem
  .title
    height 0.8rem
    line-height @height
    font-size $fz-t3
    color $c-b1
    width 100%
    background-color #fff
    display flex
    justify-content space-between
    .tab_lf
      display flex
      align-items center
      .red-icon
        display inline-block
        width 0.06rem
        height 0.32rem
        margin 0 0.20rem 0 0.28rem
        background-color $blue
        border-radius 0.02rem
  .info_ul
    background-color #fff
    .info_li
      min-height 0.8rem
      border-top 1px solid #f4f4f4
      display flex
      align-items center
      .in_left
        display inline-block
        flex 0 0 2.4rem
        padding-right 0.28rem
        box-sizing border-box
        text-align right
        line-height .35rem
        .red_x
          color #cd3c29
      .in_right
        flex 1
        input
          outline none
          line-height 0.6rem
          width 100%
  .btn_in
    border-top 1px solid #f4f4f4
    text-align center
    padding 0.2rem 0
    background-color #fff
    .btn_w_in
      display inline-block
      height 0.6rem
      width 2.0rem
      text-align center
      line-height 0.6rem
      border-radius 0.1rem
      background-color $blue
      color #fff
      font-size 0.32rem
</style>



// WEBPACK FOOTER //
// src/components/common/infolist/infolist.vue